import Bridge from './bridge';
import ProfileActions from './profile';
import ProjectsActions from './projects';
import ChallengesActions from './challenges';
import UnityPlayActions from './play';

class Unity3D {
    constructor () {
        this.profileActions = new ProfileActions();
        this.projectsActions = new ProjectsActions();
        this.challengesActions = new ChallengesActions();
        this.playActions = new UnityPlayActions();
    }

    openChallenge (challenge) {
        this.challengesActions.sendViewChallengeMessage(challenge);
    }

    openArcade (challenge) {
        this.challengesActions.sendArcadeMessage(challenge);
    }

    maximizePlayArea () {
        this.playActions.sendViewMaximizeAndPlayMessage();
    }

    minimizePlayArea () {
        this.playActions.sendViewMinimizeMessage();
    }
}

const instance = new Unity3D();
export default instance;
